$(document).ready(function() {
    let trashIcon = $('input[name="trashIcon"]').val();
    let cotizacionImage = $('input[name="cotizacion"]').val();
    let productQty;
    var qtySets = [];
    let errorSintrGif = $('input[name="errorSintrGif"]').val();
    /**
    * Creacion de template.
    *
    * @param {response} product - Array de los detalles del producto.
    * @returns {template} Template a renderizar.
    */
    function createProductTemplate(product) {
        let pza = product.quantity == 1 ? "" : "s";
        let galones = false;
        let stringUnit = "";
        if ((product.salesUnit == "Galón" || product.salesUnit == "galón") && product.quantity !== 1 ) {
            let subStr = product.salesUnit.trim();
            subStr = subStr.substring(0, 3);
            galones = true;
            stringUnit = subStr + "ones";
        }
        if(!galones){
            stringUnit = product.salesUnit ? product.salesUnit : "pieza";
            stringUnit += pza;
        }
        return `
        <div class="d-flex justify-content-between align-items-start element-with-line product-in-list" data-pid="${product.productId}" style="height: 66px">
            <!-- Primer elemento: Imagen del producto -->
            <div class="pr-2">
                <img src="${product.image}" style="height: 48px; width: 48px; object-fit: cover;">
            </div>
            <!-- Segundo elemento: Nombre y cantidad de producto -->
            <div class="flex-grow-1 mx-2 text-truncate product-name-modal">
                <div class="product-name-text">${product.name}</div>
                <span class="productos-en-lista">${product.quantity} ${stringUnit}</span>
            </div>
            <!-- Tercer elemento: Costo del producto -->
            <div class="mx-2 box-price">
                <p class="price-total-product m-0">$${product.totalPrice}</p>
            </div>

            <!-- Cuarto elemento: Icono de bote de basura -->
            <div id="deleteProductFromQuoteList" class="text-modal ml-2">
                <img src="${trashIcon}" class="icon-trash" alt="trashIcon">
            </div>
        </div>`    
    };
    /**
    * Creacion de template.
    *
    * @param {response} listItem - Array de los detalles de la lista.
    * @returns {template} Template a renderizar.
    */
    function renderTemplateList(listItem){
        let qtyProd = listItem.cantidad == 1 ? "producto" : "productos";
        return `
        <div class="row align-items-start no-gutters element-with-line items-list" data-listId="${listItem.listId}" style="min-height: 66px">
            <!-- Primer elemento: Radio Buton -->
            <div class="col-1 radio-box">
            <input type="radio" id="radio${listItem.listId}" name="list">
            <label for="radio${listItem.listId}"></label>
            </div>
            <div class="col-1 image-quote-box">
                <img src="${cotizacionImage}" alt="trashIcon">
            </div>
            <div class="col-7">
                <p class="product-name-modal pl-1 pl-sm-0">${listItem.name}<br>
                <span class="productos-en-lista">${listItem.cantidad} ${qtyProd}</span></p>
            </div>
            <div class="col-4 col-sm-3">
                <p class="w-100 price-total-product">$${listItem.total}</p>
            </div>
        </div>
        `
    };
    // Crear el evento personalizado
    $(document).on('processQuotation', function(e, quotationName, productId, productQtty, url, qtySets1) {
        let data = {
            quoteName: quotationName,
            productId: productId,
            productQuantity: productQtty,
            arrayQuantity: JSON.stringify(qtySets1)
        }
        $('#quotationModal').spinner().start();
        $.ajax({
            url: url,
            data: data,
            type: 'POST',
            success: function(response) {
                if(response && response.success && response.detailOpenList) {
                    let products = response.detailOpenList.products;
                    $('#quotationName').addClass('d-none');
                    $('#sendToList').addClass('d-none');
                    let nameList = $('.nameList');
                    let numProduct = $('.numProduct.totals');
                    // Agrega un elemento <p> a nameList
                    nameList.append('<p class="name-list">' + response.detailOpenList.nameList + '</p>');

                    // Agrega dos elementos <p> a numProduct
                    numProduct.append(`<p class="productos-totales">Lista de productos (${response.totalProducts})</p>`);
                    // eslint-disable-next-line no-useless-concat
                    numProduct.append('<p class="price-grand-total">' + "Total: " +'$' + response.grandTotal +'</p>');
                    $('.listCreated').removeClass('d-none');
                    $('.containerCreateFirstQuote').addClass('d-none');
                    $('#back-button').addClass('d-none');
                    products.forEach(function(product) {
                        let templateRender = createProductTemplate(product);
                        $('.list-product-add').append(templateRender);
                    });
                }else if (!response.success && response.message) {
                    $('#quotationName').addClass('is-invalid');
                    $('#quotationNameError').text(response.message);
                }
                $.spinner().stop();
            },
            error: function() {
                $.spinner().stop();
                let msj = $('#mensajeErrorGral').val();
                $('.modal-content').empty();
                $('.modal-content').append(`
                <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
                <p class="mb-3">${msj}</p>
                <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
                $('#quotationModal').on('click','#goNavigate', ()=> {
                    setTimeout(()=> {
                        window.location.reload();
                    },200)
                });
            }
        });
    });


    /**
     * Funcion para actualizar las variables de sesion, y no queden en cache 
     * */
    function updateVariables() {
        let urlUpdateVariables = $('#updateVariables').val();
        $.ajax({
            url: urlUpdateVariables,
            type: 'GET',
            success: function() {
                $('#quotationModal').modal('show');
            }
        });
    }

    $('.generate-quotation').on('click', function() {
        $('#quotationModal').appendTo('body');
        updateVariables();
        let isAuth = $('.is-authenticated-header').length > 0;
        if (!isAuth) {
            return;
        }
        let el = $(this);
        let productId = el.closest('.setProductDesc').data("pid") || el.closest('.set-item').data("pid") || el.closest('.product-detail').data("pid");
        const url = $('#endpointOpenList').val();
        $('#quotationModal').data('product-id', productId);
        
        if ( el.closest('.set-item')) {
            productQty = el.closest('.set-item').find('#quantity-1').val() || el.closest('.set-item').find('#CantidadProd').val()
        }
        qtySets.length = 0;
        $('.set-item').each(function(){
            var quantity = $(this).find('#quantity-1').val() || $(this).find('#CantidadProd').val();
            var pid = $(this).data("pid");
            var productSet = {
                quantity: quantity, 
                productId: pid
            }
            qtySets.push(productSet);
        });
        if (qtySets.length === 0) {
            productQty = $('.product-detail').find('#quantity-1').val() || $('.product-detail').find('#CantidadProd').val()
        }

        let data = {
            productId: productId,
            productQty: productQty,
            arrayQuantity: JSON.stringify(qtySets)
        }
        $.spinner().start();
        $.ajax({
            url: url,
            data: data,
            type: 'POST',
            success: function(response) {
                $('#quotation-modal-label').text('¿Deseas iniciar una cotización?');
                if(response && !response.openList) {
                    $('.containerCreateFirstQuote').removeClass('d-none');
                    $('.containerCotizacionesCreadas').addClass('d-none');
                    if(response.listCreated < 1){
                        $('#addToExistingQuotation').addClass('d-none');
                        localStorage.setItem('notList', true);
                        $('#createNewQuotation').trigger('click');
                    }else if(!$('#quotationNameInput').hasClass('d-none')){
                        $('#quotation-modal-label').text('Crear cotización');
                    }else{
                        localStorage.removeItem('notList');
                    }
                }
                if(response && response.success && response.detailOpenList) {
                    $('#quotation-modal-label').text('Crear una cotización')
                    $('.containerCreateFirstQuote').addClass('d-none');
                    let products = response.detailOpenList.products;
                    $('#quotationName').addClass('d-none');
                    $('#sendToList').addClass('d-none');
                    let nameList = $('.nameList');
                    let numProduct = $('.numProduct.totals');
                    nameList.empty();
                    numProduct.empty();

                    // Agrega un elemento <p> a nameList
                    nameList.append('<p class="name-list">' + response.nameList + '</p>');

                    // Agrega dos elementos <p> a numProduct
                    numProduct.append(`<p class="productos-totales">Lista de productos (${response.totalProducts})</p>`);
                    // eslint-disable-next-line no-useless-concat
                    numProduct.append('<p class="price-grand-total">' + "Total: " + '$' + response.grandTotal +'</p>');
                    $('.listCreated').removeClass('d-none');
                    $('.list-product-add').empty();
                    $('.containerCreateFirstQuote').addClass('d-none');
                    products.forEach(function(product) {
                        let templateRender = createProductTemplate(product);
                        $('.list-product-add').append(templateRender);
                    });
                }
                $.spinner().stop();
            },
            error: function() {
                $.spinner().stop();
                let msj = $('#mensajeErrorGral').val();
                $('.modal-content').empty();
                $('.modal-content').append(`
                <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
                <p class="mb-3">${msj}</p>
                <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
                $('#quotationModal').on('click','#goNavigate', ()=> {
                    setTimeout(()=> {
                        window.location.reload();
                    },200)
                });
            }
        });
    });

    $('#addToExistingQuotation').on('click', function() {
        let url = $('#endpointGetQuotesCreated').val();
        $.ajax({
            url: url,
            type: 'GET',
            success: function(response) {
                if(response.success && response.detail){
                    $('.containerCreateFirstQuote').addClass('d-none');
                    $('.containerCotizacionesCreadas').removeClass('d-none');
                    $('#back-button').removeClass('d-none');
                    $('#quotation-modal-label').text('Agregar a una cotización');
                    let detail = response.detail;
                    $('.container-cotizaciones-creadas-list').empty();
                    detail.forEach(function(listItem) {
                        let templateRender = renderTemplateList(listItem);
                        $('.container-cotizaciones-creadas-list').append(templateRender);
                    });
                    $('.container-cotizaciones-creadas-list').removeClass('.invalid-feedback');
                    $('#error-choose-list').text('');
                }
            },
            error: function(error){
                let msj = $('#mensajeErrorGral').val();
                $('.modal-content').empty();
                $('.modal-content').append(`
                <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
                <p class="mb-3">${msj}</p>
                <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
                $('#quotationModal').on('click','#goNavigate', ()=> {
                    setTimeout(()=> {
                        window.location.reload();
                    },200)
                });
            }
        });
    });

    $('#quotationModal').on('click', '#saveListInQuote', function() {
        let selectedRadio = $('input[type="radio"][name="list"]:checked');
        let url = $("#endpointAddQuoteCreate").val();
        if (selectedRadio.length > 0) {
            let selectedListId = selectedRadio.closest('.items-list').attr("data-listId");
            var pid = $("#quotationModal").data("product-id");
            let data = {
                listId: selectedListId,
                productQty: productQty,
                productId: pid,
                arrayQuantity: JSON.stringify(qtySets)
            }
            $.ajax({
                url: url,
                method: 'POST',
                data: data,
                success: function(response) {
                    if(response && response.success && response.detailOpenList) {
                        $('.containerCotizacionesCreadas').addClass('d-none');
                        $('.containerCotizacionesCreadas').empty();
                        let products = response.detailOpenList.products;
                        let nameList = $('.nameList');
                        let numProduct = $('.numProduct.totals');
                        $('#back-button').addClass('d-none');
                        // localStorage.setItem('nameQuote', response.nameList);
                        // Agrega un elemento <p> a nameList
                        nameList.append('<p class="name-list">' + response.nameList + '</p>');
                        // Agrega dos elementos <p> a numProduct
                        numProduct.append(`<p class="productos-totales">Lista de productos(${response.totalProducts})</p>`);
                        // eslint-disable-next-line no-useless-concat
                        numProduct.append('<p class="price-grand-total">' + "Total: " + '$' + response.grandTotal + '</p>');
                        $('.listCreated').removeClass('d-none');
                        $('.list-product-add').empty();
                        products.forEach(function(product) {
                            let templateRender = createProductTemplate(product);
                            $('.list-product-add').append(templateRender);
                        });
                    }
                    $.spinner().stop();
                },
                error: function(error) {
                    let msj = $('#mensajeErrorGral').val();
                    $('.modal-content').empty();
                    $('.modal-content').append(`
                        <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
                        <p class="mb-3">${msj}</p>
                        <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
                    $('#quotationModal').on('click','#goNavigate', ()=> {
                        setTimeout(()=> {
                            window.location.reload();
                        },200)
                    });
                }
            });
        } else {
            $('.container-cotizaciones-creadas-list').addClass('is-invalid');
            $('#error-choose-list').text('Por favor, selecciona una lista');
        }
    });

    $('#quotationName').on('focus', function() {
        if ($('#quotationName').hasClass('is-invalid')) {
            $('#quotationName').removeClass('is-invalid');
            $('#quotationNameError').text('');
        }
    });

    $('#quotationModal').on('click', '#createNewQuotation', function() {
        let existeLista = localStorage.getItem('notList');
        if (existeLista !== "true") $('#back-button').removeClass('d-none');
        $('#quotationNameInput').removeClass('d-none');
        $('#quotation-modal-label').text(' Crear una cotización');
        if (!$('#quotationNameInput').hasClass('d-none')) {
            // Eliminar el botón con el ID 'sendToList' del DOM
            $('#sendToList').remove();
            let buttonCreate = `
            <button type="button" id="sendToList" class="btn btn-primary col-12 mb-2">Crear cotización</button>
            `;
            $('#quotationNameInput').after(buttonCreate);
        } else {
            $('#sendToList').removeClass('d-none')
        }
        $('#createNewQuotation').addClass('d-none');
        $('#addToExistingQuotation').addClass('d-none');
    });

    $('#back-button').on('click', function() {
        $('#quotation-modal-label').text('¿Deseas iniciar una cotización?');
        $('#quotationNameInput').addClass('d-none');
        $('#createButtonContainer').addClass('d-none');
        $('.containerCotizacionesCreadas').addClass('d-none');
        $('.containerCreateFirstQuote').removeClass('d-none');
        $('#createNewQuotation').removeClass('d-none');
        if(localStorage.getItem('notList') === "true"){
            $('#addToExistingQuotation').addClass('d-none');
        }else{
            $('#addToExistingQuotation').removeClass('d-none');
        }
        $('#sendToList').addClass('d-none');
        $('#back-button').addClass('d-none');
    });

    $('#quotationModal').on('click', '#sendToList', function () {
        const quotationName = $('#quotationName').val();
        const productId = $('#quotationModal').data('product-id');
        const url = $('#endpointCreateList').val();
        if (quotationName === "") {
            $('#quotationName').addClass('is-invalid');
            $('#quotationNameError').text('Por favor, ingresa un nombre para la cotización.'); 
            return;
        }
        $('#quotationName').removeClass('is-invalid');
        $('#quotationNameError').text('');
        localStorage.setItem('nameQuote', quotationName)
        $(document).trigger('processQuotation', [quotationName, productId, productQty, url, qtySets]);
    });

    $('#quotationModal').on('click', '#deleteProductFromQuoteList', function() {
        const productContainer = $(this).closest('.product-in-list');
        const productId = productContainer.data('pid');
        const data = {
            productId: productId
        } 
        const url = $('#endpointRemoveItem').val();
        $.ajax({
            url: url,
            data: data,
            type: 'POST',
            success: function(response) {
                if(response && response.success && response.detailOpenList && response.removeItem && response.totalProducts > 0) {
                    $('.containerCreateFirstQuote').addClass('d-none');
                    let quotationName = response.nameList;
                    let products = response.detailOpenList.products;
                    // let bodyModal = $('.list-body-modal');
                    let nameList = $('.nameList');
                    let numProduct = $('.numProduct.totals');
                    nameList.empty();
                    numProduct.empty();

                    // Agrega un elemento <p> a nameList
                    nameList.append('<p class="name-list">' + quotationName + '</p>');

                    // Agrega dos elementos <p> a numProduct
                    numProduct.append(`<p class="productos-totales">Lista de productos(${response.totalProducts})</p>`);
                    // eslint-disable-next-line no-useless-concat
                    numProduct.append('<p class="price-grand-total">' + "Total: " + '$' + response.grandTotal + '</p>');
                    $('.listCreated').removeClass('d-none');
                    $('.list-product-add').empty();
                    $('.containerCreateFirstQuote').addClass('d-none');
                    products.forEach(function(product) {
                        let templateRender = createProductTemplate(product);
                        $('.list-product-add').append(templateRender);
                    });
                } else {
                    $('#quotationModal').modal('hide');
                }
            },
            error: function() {
                let msj = $('#mensajeErrorGral').val();
                $('.modal-content').empty();
                $('.modal-content').append(`
                <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
                <p class="mb-3">${msj}</p>
                <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
                $('#quotationModal').on('click','#goNavigate', ()=> {
                    setTimeout(()=> {
                        window.location.reload();
                    },200)
                });
            }
        });
    });

    $('#quotationModal').on('click', '#generateQuotation', function() {
        const url = $('#endpointCreateQuote').val();
        let imageSuccess = $('input[name="imageSuccessPdp"]').val();
        $('#quotationModal').spinner().start();
        $.ajax({
            url: url,
            type: 'POST',
            success: function(response) {
                if (response.searchImpressionData) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ecommerce: null});
                    window.dataLayer.push(JSON.parse(response.searchImpressionData));
                }
                if (response.blockSale) {
                    $('.modal-content').find('button.close').click();
                    let errorModal = response.errorModalBlockSale;
                    var errorModalGeneric = $('#errorModalGeneric');
                    if (!errorModalGeneric.length) {
                        $('body').append(errorModal);
                    }
                    $('#errorModalGeneric').modal('show');
                    $.spinner().stop();
                    return;
                }
                $.spinner().stop();
                if (response.success && !response.error && response.folio) {
                    let mensaje = $("#mensajeExitoso").val();
                    $('.modal-content').empty();
                    var resServiceSuccess = `
                    <div clss="d-flex align-item p-4">
                    <div class="imageSuccess text-center">
                        <img src=${imageSuccess} height=250 width=250 class="img-fluid" alt="Imagen descriptiva">
                    </div>
                    <div class="texto succes-text-quote text-center mb-2">
                        <p><b>Has creado la cotización con éxito.<br>
                        Folio de cotización ${response.folio}</b></p>
        
                        <span>${mensaje}</span>
                    </div>
                    <div class="botones">
                        <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>
                        <a href=${response.URL} target="_blank">
                            <button type="button" class="btn btn-outline-secondary-custom col-12 quote-pdf">Descargar cotización</button>
                        </a>
                        <input type="hidden" class="isDowloadQuotesInPdp" data-url="${response.URL}" data-cta="${response.folio}"/>
                    </div>`;
                    $('.modal-content').append(resServiceSuccess);
                    $.spinner().stop();
                } else if (!response.success && response.error) {
                    $('.modal-content').empty();
                    let resServiceFail = `
                    <div class="text-center modal-tittle-custom mb-3">
                        <p>${response.error}</p>
                    </div>
                    <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>
                    `
                    $('.modal-content').append(resServiceFail);
                }
                $('#quotationModal').on('click','#goNavigate', ()=> {
                    var isData = $('.isDowloadQuotesInPdp');
                    var isNombre = (isData[0].attributes.getNamedItem('data-url').value).split('/');
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'click_cta',
                        'section' : 'Modal de cotización',
                        'file_name' : isNombre[isNombre.length - 1],
                        'link_text' : isData[0].attributes.getNamedItem('data-url').value,
                        'cta_type' : 'Seguir comprando'
                    });
                    setTimeout(()=> {
                        window.location.reload();
                    },200)
                });
                $('#quotationModal').on('click', '.quote-pdf', function(event) {
                    $('#quotationModal').modal('hide');
                    var isData = $('.isDowloadQuotesInPdp');
                    var isNombre = (isData[0].attributes.getNamedItem('data-url').value).split('/');
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'click_cta',
                        'section' : 'Modal de cotización',
                        'file_name' : isNombre[isNombre.length - 1],
                        'link_text' : isData[0].attributes.getNamedItem('data-url').value,
                        'cta_type' : 'Descargar cotización'
                    });
                    window.dataLayer.push({
                        'event': 'file_download',
                        'file_extension' : 'PDF',
                        'file_name' : isNombre[isNombre.length - 1],
                        'link_text' : isData[0].attributes.getNamedItem('data-url').value,
                        'link_url' : isData[0].attributes.getNamedItem('data-url').value
                    });
                    setTimeout(()=> {
                        window.location.reload();
                    },200)
                });
            },
            error: function() {
                $.spinner().stop();
                let msj = $('#mensajeErrorGral').val();
                $('.modal-content').empty();
                $('.modal-content').append(`
                <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
                <p class="mb-3">${msj}</p>
                <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
                $('#quotationModal').on('click','#goNavigate', ()=> {
                    setTimeout(()=> {
                        window.location.reload();
                    },200)
                });
            }
        });
    });
});